import { Admin, Resource } from 'react-admin';
import UserIcon from '@material-ui/icons/Group';
import CarIcon from '@material-ui/icons/DirectionsCar';
import Settings from '@material-ui/icons/Settings';
import { CustomersList } from './components/customer/customers-list';
import { CreateCustomer, EditCustomer } from './components/customer/customer-edit';
import { CustomerShow } from './components/customer/customer-show';
import { DriversList } from './components/driver/drivers-list';
import { CreateDriver, EditDriver } from './components/driver/drivers-edit';
import { DriverShow } from './components/driver/driver-show';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { createBrowserHistory as createHistory } from 'history';
import { config } from './components/auth/config';
import { useAuthProvider } from './components/auth/authProvider';
import { AdminUserPropsShow } from './components/admin/admin-show';
import { AdminList } from './components/admin/admin-list';
import { verifyAccess } from './utils/resourcePermissons';
import { AddressShow } from './components/address/address-show';
import { CreateAddress, EditAddress } from './components/address/address-edit';
import LoginPage from './components/sign-in/LoginPage';
import LogoutButton from './components/sign-in/LogoutButton'
import { CreateNote } from './components/note/note-create';
import { EditNote } from './components/note/note-edit';
import { NoteShow } from './components/note/note-show';
import { DataProvider } from './data-provider';
import customRoutes from './customRoutes';

export const dataProvider = new DataProvider()

const App: React.FC = () => {
  const history = createHistory();
  
  const oktaAuth = new OktaAuth({
    ...config,
  });
  
  const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri:string) => {
    history.replace(toRelativeUrl(originalUri, window.location.origin));
  };

  const authProvider = useAuthProvider(oktaAuth, history);
  return (  
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <Admin customRoutes={customRoutes} loginPage={LoginPage} logoutButton={LogoutButton} dataProvider={dataProvider} authProvider={authProvider} history={history} title='React admin' disableTelemetry>
        {(permissions: string[]) => {
          return [
            verifyAccess(permissions, 'customer', 'read') ?
              <Resource name="profiles"
                options={{ label: 'Customers' }}
                list={CustomersList}
                show={CustomerShow}
                create={verifyAccess(permissions, 'customer', 'create') ? CreateCustomer : undefined}
                edit={verifyAccess(permissions, 'customer', 'update') ? EditCustomer : undefined}
                icon={UserIcon} /> : null,
            verifyAccess(permissions, 'driver', 'read') ?
              <Resource name="drivers"
                options={{ label: 'Drivers' }}
                list={DriversList}
                show={DriverShow} 
                create={verifyAccess(permissions, 'driver', 'create') ? CreateDriver: undefined}
                edit={verifyAccess(permissions, 'driver', 'update') ? EditDriver : undefined}
                icon={CarIcon} /> : null,
            verifyAccess(permissions, 'driver', 'delete') && verifyAccess(permissions, 'customer', 'delete') ?
              <Resource name="customer-and-driver"
                options={{ label: 'Admin' }} 
                list={AdminList} show={AdminUserPropsShow} icon={Settings} /> : null,
            <Resource name="addresses"
              edit={verifyAccess(permissions, 'customer', 'update') ? EditAddress : undefined}
              create={verifyAccess(permissions, 'customer', 'create') ? CreateAddress : undefined}
              show={AddressShow}/>,
            <Resource name="delivery-zone/search"/>,
            <Resource name="devices"/>,
            <Resource name="notes" create={CreateNote} edit={EditNote} show={NoteShow} />,
          ]}
        }
      </Admin>
    </Security>
  )
};

export default App;
